module.exports = __webpack_public_path__ + "img/68.e5656044.jpg";